<div class="container">
  <div class="row no-gutters">

    <div class="col-12">

      <div class="d-flex popup-head align-items-center">
        <div class="popup-title pr-0" translate>lblRolesRights</div>
        <div class="popup-title mr-auto pl-2" translate>({{role.roleName}})</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
        
      </div>
      <div class="scrollbar">
        <div class="card-content">
          
            <div class="row">
              <div class="col-12">
                <table class="tablest1" aria-describedby="active">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 40%" translate>lblModule</th>
                      <th scope="col" style="width: 15%" translate>lblView</th>
                      <th scope="col" style="width: 15%" translate>lblCreate</th>
                      <th scope="col" style="width: 15%" translate>lblEdit</th>
                      <th scope="col" style="width: 15%" translate>lblDelete</th>
                    </tr>
                  </thead>
                  <ng-container *ngIf="roleDetails && roleDetails.moduleList">
                  <tbody *ngFor="let Module of roleDetails.moduleList; let i = index;">
                    <tr class="bg-primary">
                      <td style="color: #212529; font-weight: 700">
                        <ng-container *ngIf="Module.moduleDisplayName; else Else">
                          {{Module.moduleDisplayName | translate}}
                        </ng-container>
                        <ng-template #Else>
                          {{Module.moduleName}}
                        </ng-template>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <ng-container *ngIf="roleDetails && roleDetails.roleDetailsList ">
                      <tr *ngFor="let roleDetailsList of roleDetails.roleDetailsList; let i = index;">
                        <ng-container *ngIf="roleDetailsList.moduleName === Module.moduleName && (roleDetailsList.subModuleDisplayName !== 'lblRentalCars'
                          || (roleDetailsList.subModuleDisplayName === 'lblRentalCars' && IsRentalCarActive ))">
                          <td>
                            <ng-container *ngIf="roleDetailsList.moduleDisplayName; else Else">
                              {{roleDetailsList.subModuleDisplayName | translate}}
                            </ng-container>
                            <ng-template #Else>
                              {{roleDetailsList.subModuleName}}
                            </ng-template>
                          </td>
                          <td>
                            <div class="custom-control custom-switch" *ngIf ="roleDetailsList.isViewable">
                              <input type="checkbox" class="custom-control-input" id="users-CanView{{i}}"
                                [disabled]="checkIfDisabled(i)" [(ngModel)]="roleDetailsList.canView"
                                (ngModelChange)="onCanViewChange($event, i)">
                              <label class="custom-control-label" for="users-CanView{{i}}"></label>
                            </div>
                          </td>
                          <td>
                            <div class="custom-control custom-switch" *ngIf ="roleDetailsList.isViewable && roleDetailsList.isCreatable">
                              <input type="checkbox" class="custom-control-input" id="users-CanAdd{{i}}"
                                [disabled]="checkIfDisabled(i)" [(ngModel)]="roleDetailsList.canAdd" (ngModelChange)="onRightsChange($event, i)">
                              <label class="custom-control-label" for="users-CanAdd{{i}}"></label>
                            </div>
                          </td>
                          <td>
                            <div class="custom-control custom-switch" *ngIf ="roleDetailsList.isViewable && roleDetailsList.isEditable">
                              <input type="checkbox" class="custom-control-input" id="users-CanEdit{{i}}"
                                [disabled]="checkIfDisabled(i)" [(ngModel)]="roleDetailsList.canEdit" (ngModelChange)="onRightsChange($event, i)">
                              <label class="custom-control-label" for="users-CanEdit{{i}}"></label>
                            </div>
                          </td>
                          <td>
                            <div class="custom-control custom-switch" *ngIf ="roleDetailsList.isViewable && roleDetailsList.isDeletable">
                              <input type="checkbox" class="custom-control-input" [disabled]="checkIfDisabled(i)"
                                id="users-CanDelete{{i}}" [(ngModel)]="roleDetailsList.canDelete" (ngModelChange)="onRightsChange($event, i)">
                              <label class="custom-control-label" for="users-CanDelete{{i}}"></label>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </ng-container>
                  </tbody>
                </ng-container>
                </table>
              </div>
            </div>
          
        </div>
      </div>
      <div class="p-3 bg-light pp-footer-top-brdr">
     
      
        <div class="d-flex flex-sm-row flex-column justify-content-end">
          <button type="button" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" (click)="onSaveChanges()"
            translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
          <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
        </div>
     
    </div>
    </div>
  </div>
</div>